import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building } from "lucide-react";
import { useRealtimeFlights } from "@/hooks/useRealtimeFlights";

const OverviewPage = () => {
  useRealtimeFlights();

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Building className="h-8 w-8" />
          Organization Dashboard
        </h1>
        <p className="text-muted-foreground mt-2">
          Manage your organization's flight information, cities, aircraft types, and announcements
        </p>
      </div>

      <Card>
          <CardHeader style={{ backgroundColor: 'orange' }}>
            <CardTitle className="flex items-center gap-2">
              <img src="/NAC_Icon_Only.png" alt="NAC Logo" className="h-5 w-5" />
              Real-time Updates
            </CardTitle>
            <CardDescription>
              Your flight updates are automatically synchronized across all users
            </CardDescription>
          </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="p-4 border rounded-lg">
              <h3 className="font-medium">Update Flight Status</h3>
              <p className="text-sm text-muted-foreground">
                Status changes are instantly visible to all users and administrators
              </p>
            </div>
            <div className="p-4 border rounded-lg">
              <h3 className="font-medium">Modify Schedule</h3>
              <p className="text-sm text-muted-foreground">
                Time changes trigger automatic notifications to administrators
              </p>
            </div>
            <div className="p-4 border rounded-lg">
              <h3 className="font-medium">Add Status Notes</h3>
              <p className="text-sm text-muted-foreground">
                Detailed change logs are maintained for audit purposes
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewPage;
